import { SearchInput } from '@/components/ui/SearchInput';
import { cn } from '@/lib/utils';

export const RoundSearchInput = ({
  className,
  ...props
}: React.ComponentProps<typeof SearchInput>) => (
  <SearchInput
    {...props}
    className={cn('h-9 flex-none rounded-full py-0 pr-1.5', className)}
  />
);
